/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ObjectLocationSeoDataNested
 */
export interface ObjectLocationSeoDataNested {
  /**
   *
   * @type {string}
   * @memberof ObjectLocationSeoDataNested
   */
  locationSlug?: string | null
  /**
   *
   * @type {string}
   * @memberof ObjectLocationSeoDataNested
   */
  header?: string | null
  /**
   *
   * @type {string}
   * @memberof ObjectLocationSeoDataNested
   */
  titleTag?: string | null
  /**
   *
   * @type {string}
   * @memberof ObjectLocationSeoDataNested
   */
  descriptionTag?: string | null
}

/**
 * Check if a given object implements the ObjectLocationSeoDataNested interface.
 */
export function instanceOfObjectLocationSeoDataNested(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function ObjectLocationSeoDataNestedFromJSON(json: any): ObjectLocationSeoDataNested {
  return ObjectLocationSeoDataNestedFromJSONTyped(json, false)
}

export function ObjectLocationSeoDataNestedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ObjectLocationSeoDataNested {
  if (json === undefined || json === null) {
    return json
  }
  return {
    locationSlug: !exists(json, 'locationSlug') ? undefined : json['locationSlug'],
    header: !exists(json, 'header') ? undefined : json['header'],
    titleTag: !exists(json, 'titleTag') ? undefined : json['titleTag'],
    descriptionTag: !exists(json, 'descriptionTag') ? undefined : json['descriptionTag'],
  }
}

export function ObjectLocationSeoDataNestedToJSON(
  value?: ObjectLocationSeoDataNested | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    locationSlug: value.locationSlug,
    header: value.header,
    titleTag: value.titleTag,
    descriptionTag: value.descriptionTag,
  }
}
